const productFamilies = [
  {
    category: "Keyboards",
    material: "Aluminum top plate, PBT keycaps, ABS frame",
    images: [
      "/img/products/p01-01.jpg",
      "/img/products/p01-02.jpg",
      "/img/products/p01-03.jpg",
      "/img/products/p01-04.jpg",
    ],
    description: [
      "A compact 68-key mechanical keyboard with full arrow keys and a practical navigation cluster.",
      "Tri-mode connectivity lets you switch between Bluetooth 5.0, 2.4 GHz wireless and wired USB-C.",
      "Smooth Green Tea Red switches, durable PBT keycaps and adjustable RGB lighting make it equally suited to work and gaming.",
    ],
    Features: [
      "68-key compact layout",
      "Bluetooth, 2.4 GHz and USB-C connectivity",
      "Green Tea Red linear switches",
      "Adjustable RGB backlighting",
      "Up to 120 hours of battery life",
    ],
    variants: [
      {
        name: "XM-RE68 Tri-Mode Mechanical Keyboard - White Ice Blue",
        price: "99.99",
        colors: ["White Ice Blue"],
        imageIndex: 0,
      },
      {
        name: "XM-RE68 Tri-Mode Mechanical Keyboard - Black RGB",
        price: "109.99",
        colors: ["Black RGB"],
        imageIndex: 3,
      },
      {
        name: "XM-RE68 Dual-Color Mechanical Keyboard Set",
        price: "119.99",
        colors: ["White Ice Blue", "Black RGB"],
        imageIndex: 2,
      },
    ],
  },
  {
    category: "Keyboards",
    material: "ABS frame and abrasion-resistant keycaps",
    images: [
      "/img/products/p02-01.jpg",
      "/img/products/p02-02.jpg",
      "/img/products/p02-03.jpg",
      "/img/products/p02-04.jpg",
      "/img/products/p02-05.jpg",
    ],
    description: [
      "A full-size pink keyboard with multicolor illumination designed to brighten office, study and gaming setups.",
      "Low-profile mechanical-feel keys provide quiet, responsive typing while the matching mouse follows a comfortable ergonomic shape.",
      "The wired USB connection is completely plug-and-play and keeps every keypress and click free from wireless lag.",
    ],
    Features: [
      "Multicolor RGB backlight",
      "Full-size layout with number pad",
      "Plug-and-play USB connection",
      "Quiet mechanical-feel keys",
      "Windows, macOS, Chromebook and Linux compatible",
    ],
    variants: [
      {
        name: "G103 Pink RGB Wired Gaming Keyboard",
        price: "109.99",
        colors: ["Blush Pink"],
        imageIndex: 0,
      },
      {
        name: "G103 Pink RGB Keyboard and Mouse Combo",
        price: "129.99",
        colors: ["Blush Pink"],
        imageIndex: 1,
      },
      {
        name: "G103 Rainbow Office and Gaming Keyboard",
        price: "119.99",
        colors: ["Pink Rainbow"],
        imageIndex: 4,
      },
    ],
  },
  {
    category: "Mouses",
    material: "Matte ABS shell with low-friction feet",
    images: [
      "/img/products/p03-01.png",
      "/img/products/p03-02.png",
      "/img/products/p03-03.jpg",
      "/img/products/p03-04.png",
      "/img/products/p03-05.png",
    ],
    description: [
      "A lightweight Morandi-style wireless mouse with a soft matte finish and a compact ergonomic shape.",
      "Silent switches keep clicks discreet in shared offices, libraries and late-night workspaces.",
      "Bluetooth and 2.4 GHz modes make it easy to move between laptops and tablets, while rechargeable power reduces battery waste.",
    ],
    Features: [
      "Ultra-quiet left and right buttons",
      "Bluetooth and 2.4 GHz dual mode",
      "Rechargeable battery",
      "Adjustable DPI control",
      "Automatic sleep and wake",
    ],
    variants: [
      {
        name: "Morandi Silent Wireless Mouse - Mint Green",
        price: "59.99",
        colors: ["Mint Green"],
        imageIndex: 0,
      },
      {
        name: "Morandi Dual-Mode Rechargeable Mouse",
        price: "69.99",
        colors: ["Mint Green"],
        imageIndex: 2,
      },
      {
        name: "Morandi 70g Travel Mouse",
        price: "79.99",
        colors: ["Mint Green"],
        imageIndex: 3,
      },
    ],
  },
  {
    category: "Mouses",
    material: "ABS shell, braided cable and PTFE feet",
    images: [
      "/img/products/p04-01.jpg",
      "/img/products/p04-02.jpg",
      "/img/products/p04-03.jpg",
      "/img/products/p04-04.png",
      "/img/products/p04-05.png",
    ],
    description: [
      "The G28 gaming mouse combines a sculpted right-handed shape with eight conveniently placed controls.",
      "Its adjustable optical sensor supports rapid movement and accurate aiming, while the wired connection delivers consistent low-latency input.",
      "Customizable RGB edge lighting and a graphic shell give the mouse a distinctive esports-inspired finish.",
    ],
    Features: [
      "Eight programmable buttons",
      "Adjustable high-DPI optical sensor",
      "Customizable RGB illumination",
      "Low-latency wired connection",
      "Braided cable and smooth PTFE feet",
    ],
    variants: [
      {
        name: "G28 RGB 8-Button Wired Gaming Mouse",
        price: "59.99",
        colors: ["Black RGB"],
        imageIndex: 0,
      },
      {
        name: "G28 Esports Optical Mouse - Cyber Graphic",
        price: "69.99",
        colors: ["Cyber Black"],
        imageIndex: 1,
      },
      {
        name: "G28 High-DPI Programmable Gaming Mouse",
        price: "79.99",
        colors: ["Black Multicolor"],
        imageIndex: 2,
      },
    ],
  },
  {
    category: "HeadPhones",
    material: "ABS charging case with soft silicone ear tips",
    images: [
      "/img/products/p05-01.jpg",
      "/img/products/p05-02.png",
      "/img/products/p05-03.png",
      "/img/products/p05-04.png",
      "/img/products/p05-05.png",
    ],
    description: [
      "Ultra-slim sleep earbuds sit securely inside the ear without creating uncomfortable pressure for side sleepers.",
      "Bluetooth 5.3 provides quick automatic pairing, while the snug silicone fit helps reduce everyday background noise.",
      "A long-lasting battery and compact display case make these earbuds ready for overnight listening and travel.",
    ],
    Features: [
      "Low-profile sleep-friendly design",
      "Bluetooth 5.3 automatic pairing",
      "Passive noise isolation",
      "Up to 14 hours per charge",
      "Three silicone ear-tip sizes included",
    ],
    variants: [
      {
        name: "Mini Sleep Earbuds - Lavender Purple",
        price: "59.99",
        colors: ["Lavender Purple"],
        imageIndex: 0,
      },
      {
        name: "Bluetooth 5.3 Side-Sleeper Earbuds",
        price: "69.99",
        colors: ["Lavender Purple"],
        imageIndex: 1,
      },
      {
        name: "Long-Life Sleep Earbuds with Digital Case",
        price: "79.99",
        colors: ["Lavender Purple"],
        imageIndex: 2,
      },
    ],
  },
  {
    category: "HeadPhones",
    material: "ABS shell with soft silicone ear tips",
    images: [
      "/img/products/p06-01.jpg",
      "/img/products/p06-02.png",
      "/img/products/p06-03.png",
      "/img/products/p06-04.png",
    ],
    description: [
      "Blue-black wireless earbuds are tuned for clear calls, energetic workouts and focused everyday listening.",
      "Dual microphones help keep speech intelligible in busy surroundings, and adaptive noise reduction limits distracting sound.",
      "The pocketable charging case extends playback beyond 40 hours and displays the remaining power at a glance.",
    ],
    Features: [
      "Dual-microphone call clarity",
      "Adaptive noise reduction",
      "Bluetooth 5.3 connectivity",
      "More than 40 hours with charging case",
      "IPX5 sweat and splash resistance",
    ],
    variants: [
      {
        name: "Blue-Black Call and Run Wireless Earbuds",
        price: "99.99",
        colors: ["Blue Black"],
        imageIndex: 0,
      },
      {
        name: "IPX5 Sport Earbuds with Digital Case",
        price: "109.99",
        colors: ["Midnight Blue"],
        imageIndex: 1,
      },
      {
        name: "40-Hour Noise-Reducing Bluetooth Earbuds",
        price: "119.99",
        colors: ["Midnight Blue"],
        imageIndex: 2,
      },
    ],
  },
  {
    category: "HeadPhones",
    material: "Resin earpieces, silicone ear tips and reinforced cable",
    images: [
      "/img/products/p07-01.jpg",
      "/img/products/p07-02.jpg",
      "/img/products/p07-03.jpg",
      "/img/products/p07-04.png",
      "/img/products/p07-05.png",
    ],
    description: [
      "These red in-ear monitors pair a vivid transparent shell with balanced Hi-Fi stereo sound.",
      "The extended cable gives streamers and creators extra freedom while preserving the zero-latency reliability of a wired connection.",
      "Three sizes of silicone tips provide a stable, comfortable seal for long listening and monitoring sessions.",
    ],
    Features: [
      "Balanced Hi-Fi stereo drivers",
      "Extended tangle-resistant cable",
      "Low-latency analog audio",
      "Secure-fit silicone ear tips",
      "Universal 3.5 mm compatibility",
    ],
    variants: [
      {
        name: "Crimson Hi-Fi In-Ear Monitor Headphones",
        price: "59.99",
        colors: ["Crystal Red"],
        imageIndex: 0,
      },
      {
        name: "Extended-Cable Live Streaming Earphones",
        price: "69.99",
        colors: ["Crimson Red"],
        imageIndex: 1,
      },
      {
        name: "Low-Latency Studio Monitor Earbuds",
        price: "79.99",
        colors: ["Red Black"],
        imageIndex: 2,
      },
    ],
  },
  {
    category: "HeadPhones",
    material: "Lightweight ABS body with flexible ear hook",
    images: [
      "/img/products/p08-01.jpg",
      "/img/products/p08-02.jpg",
      "/img/products/p08-03.jpg",
      "/img/products/p08-04.png",
    ],
    description: [
      "A rotatable open-ear Bluetooth headset that can be worn comfortably on either the left or right ear.",
      "The flexible over-ear shape stays in place without pressing into the ear canal, making it ideal for running, walking and hands-free calls.",
      "Bluetooth 5.3 and a long-lasting battery support dependable listening throughout a busy day.",
    ],
    Features: [
      "360-degree rotatable earpiece",
      "Reversible left or right-ear fit",
      "Open-ear over-ear comfort",
      "Up to 12 hours of playtime",
      "IPX5 sweat and splash resistance",
    ],
    variants: [
      {
        name: "Rotatable Open-Ear Running Headset - Black",
        price: "59.99",
        colors: ["Black"],
        imageIndex: 0,
      },
      {
        name: "Single-Ear Bluetooth Sport Headset - White",
        price: "69.99",
        colors: ["White"],
        imageIndex: 1,
      },
      {
        name: "12-Hour Reversible Over-Ear Headset",
        price: "79.99",
        colors: ["Black", "White"],
        imageIndex: 2,
      },
    ],
  },
  {
    category: "HeadPhones",
    material: "Metal earbud housing with flat reinforced cable",
    images: [
      "/img/products/p09-01.png",
      "/img/products/p09-02.jpg",
      "/img/products/p09-03.png",
      "/img/products/p09-04.png",
      "/img/products/p09-05.png",
    ],
    description: [
      "Compact blue metal earphones combine a durable housing with a secure silicone fit for comfortable everyday listening.",
      "Choose the classic 3.5 mm connector or USB-C to use the same clear, balanced sound across laptops, phones and gaming devices.",
      "The flat reinforced cable resists tangles, while the wired design avoids charging, pairing and audio-delay concerns.",
    ],
    Features: [
      "Durable lightweight metal housing",
      "3.5 mm and USB-C connector options",
      "Flat tangle-resistant cable",
      "Inline microphone and remote",
      "Three silicone ear-tip sizes included",
    ],
    variants: [
      {
        name: "Blue Metal USB-C In-Ear Earphones",
        price: "59.99",
        colors: ["Ice Blue"],
        imageIndex: 0,
      },
      {
        name: "Blue Metal 3.5 mm Hi-Fi Earphones",
        price: "69.99",
        colors: ["Ice Blue"],
        imageIndex: 1,
      },
      {
        name: "Dual-Connector Metal Earphone Set",
        price: "79.99",
        colors: ["Ice Blue"],
        imageIndex: 2,
      },
    ],
  },
  {
    category: "HeadPhones",
    material: "Textured ABS charging case with silicone ear tips",
    images: [
      "/img/products/p10-01.jpg",
      "/img/products/p10-02.png",
      "/img/products/p10-03.png",
      "/img/products/p10-04.png",
      "/img/products/p10-05.png",
    ],
    description: [
      "Retro-inspired wireless earbuds combine warm Berlin Sound tuning with a distinctive textured digital-display case.",
      "Bluetooth 5.3 keeps calls and music synchronized across phones, tablets and laptops with simple touch control.",
      "Up to eight hours per charge and more than 30 hours with the case make them a dependable everyday companion.",
    ],
    Features: [
      "Balanced Berlin Sound tuning",
      "Smart battery display",
      "Bluetooth 5.3 with low latency",
      "More than 30 hours with charging case",
      "Quick charge and touch controls",
    ],
    variants: [
      {
        name: "Berlin Sound Retro Earbuds - Caramel Brown",
        price: "99.99",
        colors: ["Caramel Brown"],
        imageIndex: 0,
      },
      {
        name: "Smart-Display Hi-Fi Bluetooth Earbuds",
        price: "109.99",
        colors: ["Caramel Brown"],
        imageIndex: 1,
      },
      {
        name: "Berlin Sound Quick-Charge Earbud Set",
        price: "119.99",
        colors: ["Caramel Brown"],
        imageIndex: 2,
      },
    ],
  },
];

const productData = productFamilies.flatMap((product, familyIndex) =>
  product.variants.map((variant, variantIndex) => {
    const images = [
      product.images[variant.imageIndex],
      ...product.images.filter((_, index) => index !== variant.imageIndex),
    ];

    return {
      id: familyIndex * 3 + variantIndex + 1,
      name: variant.name,
      category: product.category,
      price: variant.price,
      reviews: "0",
      rating: "0.0",
      image: images[0],
      images,
      size: ["One size"],
      colors: variant.colors,
      material: product.material,
      description: product.description,
      Features: product.Features,
    };
  })
);

export default productData;
